import { ActionIcon, Badge, Group, Stack, Tooltip } from "@mantine/core";
import React, { useCallback, useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { parseDateFuture } from "../../../../functions/dates";
import { updateProfile } from "../../../../api/UserAPI";
import { notifications } from "@mantine/notifications";
import { subscribeUser } from "../../../../api/AdminAPI";
import AdminInputSubscription from "../../admin/center/adminInput/AdminInputSubscription";
import { getPermission } from "../../../../functions/utilFunctions";
import { IconEdit } from "@tabler/icons-react";
import PopOver from "../../../../components/View/PopOver";
import LeftBioSaver from "../../leadsTracking/prospect/sheet/Left/LeftBioSaver";

const UserSubscriptionCell = ({ row, apiRef }) => {
  const lang = useLanguage((s) => s.language);
  const [value, setValue] = useState(row?.subscriptions?.end_date);

  const [loading, setLoading] = useState(false);

  const handleSubmitEdit = useCallback(
    (closePopover) => {
      setLoading(true);

      let d = new Date(value).toISOString();
      return subscribeUser({ end_date: d, user_id: row.id })
        .then((response) => {
          notifications.show({
            message: lang.profile.edited,
            color: "tertiary.8",
          });
          apiRef.current.updateRows([
            {
              ...row,
              subscriptions: {
                active: true,
                end_date: d,
              },
            },
          ]);
          closePopover?.();
          // handleStopEdit();
        })
        .finally(() => setLoading(false));
    },
    [apiRef, lang.profile.edited, row, value]
  );

  return (
    <Group wrap="nowrap" className="hover-source" w={"100%"} gap={0}>
      {row?.subscriptions?.subscription_id ? (
        <Tooltip
          label={`${
            lang.referral[
              row?.subscriptions?.is_canceled ? "end_date" : "renew_date"
            ]
          } ${parseDateFuture(row?.subscriptions?.end_date)}`}
        >
          <Badge color={"orange"} size="xs">
            {lang.pricing.magileads}{" "}
          </Badge>
        </Tooltip>
      ) : row?.subscriptions?.active && !row?.subscriptions?.trial ? (
        <Tooltip
          label={`${
            lang.referral[
              row?.subscriptions?.is_canceled ? "end_date" : "renew_date"
            ]
          } ${parseDateFuture(row?.subscriptions?.end_date)}`}
        >
          <Badge color={"tertiary.8"} size="xs">
            {lang.referral.active}
          </Badge>
        </Tooltip>
      ) : (
        <Tooltip
          label={
            row?.subscriptions?.trial
              ? `${lang.referral.trial} ${parseDateFuture(
                  row?.subscriptions?.end_date
                )}`
              : lang.referral.free_version
          }
        >
          <Badge color={"red"} size="xs">
            {row?.subscriptions?.trial ? lang.referral.trial_short : lang.referral.not_active}
          </Badge>
        </Tooltip>
      )}

      <PopOver
        opener={(openFunction, ref, opened) => {
          return (
            <Tooltip label={lang.prm.details.edit}>
              <ActionIcon
                ref={ref}
                variant="subtle"
                onClick={openFunction}
                className="hover-target"
                disabled={!getPermission("subscribeUser")}
                ml={8}
                size={"md"}
              >
                <IconEdit size={18} />
              </ActionIcon>
            </Tooltip>
          );
        }}
        popoverChildren={(closePopover) => (
          <Stack w={250}>
            <AdminInputSubscription
              value={value}
              onChange={setValue}
              handleStopEdit={closePopover}
              profile={row}
              apiRef={apiRef}
            />

            <LeftBioSaver
              handleClose={closePopover}
              handleSave={() => handleSubmitEdit(closePopover)}
              loading={loading}
            />
          </Stack>
        )}
        elevation={3}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        transformOrigin={{ horizontal: "center", vertical: "top" }}
      />
    </Group>
  );
};

export default UserSubscriptionCell;
